"use client";

import { useRecruitmentDashboard } from "@/modules/hooks/dashboard/useRecruitmentDashboard";
import { DashboardHeader } from "@/modules/components/dashboard/DashboardHeader";
import { DashboardEmptyState } from "@/modules/components/dashboard/DashboardEmptyState";
import { DashboardKpiSection } from "@/modules/components/dashboard/DashboardKpiSection";
import { DashboardMainAnalyticsSection } from "@/modules/components/dashboard/DashboardMainAnalyticsSection";
import { DashboardDeepInsightsSection } from "@/modules/components/dashboard/DashboardDeepInsightsSection";
import CircularProgress from "@/modules/components/commons/CircularProgress";

export default function RecruitmentDashboard() {
  const {
    fromDate,
    toDate,
    selectedJobId,
    handleFromDateChange,
    handleToDateChange,
    handleJobIdChange,
    jobOptions,
    hasData,
    kpiItems,
    conversionRate,
    funnelData,
    pipelineData,
    activeCandidates,
    aiMatchingDistribution,
    potentialZoneCount,
    radarData,
    jobTypePerformanceData,
    isLoadingApi,
  } = useRecruitmentDashboard();

  return (
    <div className="min-h-screen p-4 md:p-6 lg:p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <DashboardHeader
          fromDate={fromDate}
          toDate={toDate}
          selectedJobId={selectedJobId}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
          onJobIdChange={handleJobIdChange}
          jobOptions={jobOptions}
        />

        {isLoadingApi ? (
          <div className="flex items-center justify-center py-20">
            <CircularProgress className="h-8 w-8 text-primary" />
          </div>
        ) : !hasData ? (
          <DashboardEmptyState />
        ) : (
          <>
            <DashboardKpiSection items={kpiItems} />
            <DashboardMainAnalyticsSection
              conversionRate={conversionRate}
              funnelData={funnelData}
              pipelineData={pipelineData}
              activeCandidates={activeCandidates}
            />
            <DashboardDeepInsightsSection
              aiMatchingDistribution={aiMatchingDistribution}
              potentialZoneCount={potentialZoneCount}
              radarData={radarData}
              jobTypePerformanceData={jobTypePerformanceData}
            />
          </>
        )}
      </div>
    </div>
  );
}
